module.exports = __webpack_public_path__ + "media/images/hero_images/about-400-d6685de237b5eaee1c5984a55c8a6609.jpg";